import React, { Component } from 'react';

export class Hamburger extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.value || false
    };

  }

  componentWillReceiveProps(nextProps) {
    if(typeof nextProps.value === "boolean") {
      this.setState({
        isOpen: nextProps.value
      });
    }
  }

  render() {
    let props = {};

    if (typeof this.props.onClick === "function") {
      props.onClick = this.props.onClick;
    }

    return (
      <div className={"hamburger-container"}>
        <a id="hamburger-icon" title="Menu" { ...props } className={ this.state.isOpen ? "active" : ""}>
          <span className="line line-1" />
          <span className="line line-2" />
          <span className="line line-3" />
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/hamburger/Hamburger.js